import type { SaveStatus } from './useSpecDraft'
import { STATUS_TEXT } from './useSpecDraft'

// 자동 저장(실시간 공동 편집) 상태 표시 — 저장됨 · 시각 / 저장 중 / 연결 중 / 실패(다시 시도)
export default function SaveBadge({ status, savedAt, error, onRetry }: { status: SaveStatus; savedAt: Date; error: string | null; onRetry: () => void }) {
  const tone = status === 'saved' ? 'text-gray-400' : status === 'error' ? 'text-red-600' : 'text-amber-600'
  return (
    <span className={`text-xs whitespace-nowrap ${tone}`} title={error ?? undefined}>
      {(status === 'saving' || status === 'connecting' || status === 'reconnecting') && <span className="inline-block w-2 h-2 rounded-full bg-amber-500 animate-pulse mr-1.5 align-middle" />}
      {STATUS_TEXT[status]}
      {status === 'saved' && ` · ${savedAt.toLocaleTimeString('ko-KR', { hour12: false, hour: '2-digit', minute: '2-digit' })}`}
      {status === 'error' && <button onClick={onRetry} className="underline ml-1.5">다시 시도</button>}
    </span>
  )
}
